<template>
  <div>
    <BottomSheetModal ref="component">
      <template #header>
        <div></div>
      </template>
      <MatchFiltersList class="" />
    </BottomSheetModal>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import MatchFiltersList from './MatchFiltersList.vue'
import BottomSheetModal from '../utils/BottomSheetModal.vue'

export default defineComponent({
  name: 'MatchFiltersComponent',
  components: { MatchFiltersList, BottomSheetModal },
  props: {},
  data() {
    return {
      eventsIds: [],
    }
  },
  mounted() {
    const id = this.$Events.handleEvent(
      'show_filters_required',
      this.showFilters,
    )
    this.eventsIds.push(id)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    showFilters() {
      this.$refs.component.show()
    },
  },
  computed: {},
})
</script>
